import script from "./ClientAddRoleDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientAddRoleDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ClientAddRoleDropdown.vue?vue&type=style&index=0&id=20ea673c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20ea673c"]])

export default __exports__